import { createContext, useContext, type ReactNode } from 'react';
import type { MarketSelectorPreset } from '../MarketSelector/types';

export interface MarketDataCardMarketSelectorContextValue {
  isOpen: boolean;
  selectedMarketOrAccountNames: string[];
  selectedAggregationID: string | undefined;
  selectedAggregationLabel: string | undefined;
  favoriteAggregationPresets: MarketSelectorPreset[];
  selectAggregationPreset: (aggregationID: string) => void;
}

const MarketDataCardMarketSelectorContext = createContext<MarketDataCardMarketSelectorContextValue | undefined>(
  undefined
);

export function MarketDataCardMarketSelectorProvider({
  value,
  children,
}: {
  value: MarketDataCardMarketSelectorContextValue;
  children: ReactNode;
}) {
  return (
    <MarketDataCardMarketSelectorContext.Provider value={value}>
      {children}
    </MarketDataCardMarketSelectorContext.Provider>
  );
}

/** Undefined when the card does not wrap content in {@link MarketDataCardMarketSelectorProvider}. */
export function useMarketDataCardMarketSelectorContext() {
  return useContext(MarketDataCardMarketSelectorContext);
}
